import React, { useContext } from 'react';
import { SchibstedPrivacySettingsContext } from '../schibsted-privacy-settings-context.js';
import FinnLogo from './finn-logo.js';
import { ToriLogo } from './tori-logo.js';

export default function Logo(
    props: React.SVGProps<SVGSVGElement>,
): React.JSX.Element {
    const { brand } = useContext(SchibstedPrivacySettingsContext);
    return brand === 'FINN' ? FinnLogo(props) : ToriLogo(props);
}
